import "core-js/modules/web.dom.iterable";
//
//
//
//
import barLineChart from '@/components/bigDataChart/barLineChart';
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { queryCurveAnalysisSx } from '@/api/api';
import moment from 'moment';
export default {
  name: 'waterStatistics',
  created: function created() {
    this.queryWaterWenStatistics();
  },
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '250px'
    }
  },
  components: {
    barLineChart: barLineChart
  },
  methods: {
    queryWaterWenStatistics: function queryWaterWenStatistics() {
      var _this = this;

      var dateTime = new Date();
      var that = this;
      var yAxisData1 = [];
      var yAxisData2 = [];
      var yAxisData3 = [];
      var yAxisData4 = [];
      var xAxisData = [];
      queryCurveAnalysisSx({
        factorCategory: "12",
        id: '7',
        type: 0
      }).then(function (res) {
        if (res.success) {
          if (res.result.data.length) {
            res.result.data.forEach(function (element) {
              yAxisData1.push(element.dataCodeMap['u10301'].value);
              yAxisData2.push(element.dataCodeMap['u20101'].value);
              yAxisData3.push(element.dataCodeMap['u20201'].value);
              yAxisData4.push(element.dataCodeMap['u20301'].value);
              xAxisData.push(element.dateStr);
            });
          } else {
            xAxisData = ['2020-10-31 01', '2020-10-31 02', '2020-10-31 03', '2020-10-31 04'];
            yAxisData1 = [0, 0, 0, 0];
            yAxisData2 = [0, 0, 0, 0];
            yAxisData3 = [0, 0, 0, 0];
            yAxisData4 = [0, 0, 0, 0];
          }

          var data = {
            color: ['#8B5CFF', '#00CA69', '#898b37', '#ff9900'],
            title: ['浊度', '水位', '流量', '流速'],
            xAxisData: xAxisData,
            yAxisList: [yAxisData1, yAxisData2, yAxisData3, yAxisData4],
            unit: '',
            height: 150
          };
          console.log(data);

          _this.$refs.chart3.initBarLineChart(data);
        }
      });
    }
  }
};